
import debounce from 'lodash/debounce';
import DropdownElementTaco from './DropdownElementTaco.vue';

// 5px to give the dropdown some breathing room
const PX_BUFFER = 5;

export default {
  name: 'LegacyDropdown',
  components: {
    DropdownElementTaco,
  },
  props: {
    containerStyle: {
      type: String,
      default: '',
    },
    containerClass: {
      type: String,
      default: '',
    },
    buttonStyle: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
    },
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [String, Number],
      default: '',
    },
    highlight: {
      type: Boolean, // Highlight currently selected item
    },
  },
  data() {
    return {
      showMenu: false,
      isAbove: false,
    };
  },
  mounted() {
    this.handleDebouncedScroll = debounce(this.onScroll, 100);
    window.addEventListener('scroll', this.handleDebouncedScroll);
  },
  destroyed() {
    window.removeEventListener('click', this.clickHandler);
    window.removeEventListener('scroll', this.handleDebouncedScroll);
  },
  methods: {
    toggleMenu() {
      if (!this.showMenu) { // No need to calculate if closing dropdown
        this.calculatePosition();
      }

      this.showMenu = !this.showMenu;
      this.$emit('toggle', this.showMenu);

      if (this.showMenu) {
        window.addEventListener('click', this.clickHandler);
      }
    },
    calculatePosition() {
      // Check if need to render above menu
      const { $el: parent } = this;
      const { top: parentTop, bottom: parentBottom } = parent.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const menuHeight = this.$refs.dropdownMenu.clientHeight;

      const topPos = parentTop - menuHeight - PX_BUFFER;
      const bottomPos = parentBottom + menuHeight + PX_BUFFER;
      const bottomOverage = windowHeight - bottomPos;

      // Check if can render on bottom (default)
      // Add check that top position will show better (if both will render offscreen)
      if (bottomPos > windowHeight && topPos > bottomOverage) {
        this.isAbove = true;
      } else if (this.isAbove) {
        this.isAbove = false;
      }
    },
    clickHandler(event) {
      const { target } = event;
      const { $el } = this;

      if (!$el.contains(target)) {
        this.showMenu = false;
        this.$emit('toggle', this.showMenu);

        window.removeEventListener('click', this.clickHandler);
      }
    },
    onScroll() {
      // Check if scrolling will require dropdown to flip
      if (this.showMenu) this.calculatePosition();
    },
    onClickOption(value) {
      if (value.disabled) {
        return;
      }

      this.$emit('selected', value);
      this.toggleMenu();
    },
  },
};
